function addRemoveCompare(itemHandle) { var handle = itemHandle;

var data = '"' + handle + '"';

  if (localStorage.getItem('compare') != null ) {
      
    var compareList = localStorage.getItem('compare');
    var compareArray = JSON.parse(compareList);
  
      if (compareList.search('"' + handle + '"') != -1) {
        for (var i = 0; i < compareArray.length; i++) {
          if (compareArray[i] == handle) {
            delete compareArray[i] }
          }
        compareArray = compareArray.filter(el => Object.keys(el).length)
        localStorage.setItem("compare", JSON.stringify(compareArray));
        console.log('After: ' + compareArray);
      } else { 
        compareArray.push(JSON.parse(data)); localStorage.setItem("compare", JSON.stringify(compareArray));
      }
  
  } else {
    
    localStorage.setItem('compare', '[' + data + ']')
    
  };

};

$(document).on("click", ".compare__button", function(){
  addRemoveCompare($( this ).data( "handle" ));
});

$(document).on("click", ".product-form__remove", function(){
  addRemoveCompare($( this ).data( "handle" ));
  $( "[data-product='" + $( this ).data( "handle" ) + "']" ).remove();
});